const portalNavItems = [
    { name: "Quote Request Form", url: "/portal", icon: "quote-options", subLinks: null },
    { name: "Requests", url: "/portal/requests", icon: "quote-pending-reply", subLinks: null },
    { name: "Trips / Requests", url: "/portal/trips", icon: "plane", subLinks: null },
    { name: "Contracts & Payments", url: "/portal/contracts", icon: "quote-signing", subLinks: null },
    { name: "Bookings", url: "/portal/bookings", icon: "quotes-bookings", subLinks: null },
    { name: "Commercial", url: "/portal/commercial", icon: "owner-approval", subLinks: null },
];

const portalLogoutIcon = "arrow-right";

export { portalNavItems, portalLogoutIcon };
